/* Label typography and local, border-connected background removal. No customer image or text is sent to a service. */
(function (host) {
  'use strict';
  var fonts = [
    ['Noto Serif JP','明朝 / Noto Serif JP'],['Noto Sans JP','ゴシック / Noto Sans JP'],
    ['BIZ UDMincho','BIZ UD明朝'],['BIZ UDPMincho','BIZ UDP明朝'],['BIZ UDGothic','BIZ UDゴシック'],['BIZ UDPGothic','BIZ UDPゴシック'],
    ['Shippori Mincho','しっぽり明朝'],['Shippori Mincho B1','しっぽり明朝 B1'],['Zen Old Mincho','ZEN オールド明朝'],['Zen Antique','ZEN アンチック'],['Zen Antique Soft','ZEN アンチックソフト'],
    ['Zen Kaku Gothic New','ZEN 角ゴシック New'],['Zen Kaku Gothic Antique','ZEN 角ゴシック Antique'],['Zen Maru Gothic','ZEN 丸ゴシック'],
    ['Kaisei Decol','解星デコール'],['Kaisei HarunoUmi','解星春の海'],['Kaisei Opti','解星オプティ'],['Kaisei Tokumin','解星特ミン'],
    ['Klee One','クレー'],['Yuji Syuku','佑字 肅'],['Yuji Mai','佑字 舞'],['Yuji Boku','佑字 木'],['Hina Mincho','ひな明朝'],['Yomogi','よもぎ'],['Sawarabi Mincho','さわらび明朝'],['Sawarabi Gothic','さわらびゴシック'],
    ['Noto Serif TC','繁體宋體 / Noto Serif TC'],['Noto Sans TC','繁體黑體 / Noto Sans TC'],['Noto Serif SC','简体宋体 / Noto Serif SC'],['Noto Sans SC','简体黑体 / Noto Sans SC'],['Ma Shan Zheng','马善政毛笔楷书'],['Liu Jian Mao Cao','刘建毛草'],['Zhi Mang Xing','志莽行书'],['Long Cang','龙藏体'],['ZCOOL XiaoWei','站酷小薇'],['ZCOOL QingKe HuangYou','站酷庆科黄油'],
    ['Playfair Display','Playfair Display'],['Cormorant Garamond','Cormorant Garamond'],['Bodoni Moda','Bodoni Moda'],['Libre Baskerville','Libre Baskerville'],['Lora','Lora'],['Merriweather','Merriweather'],['Cinzel','Cinzel'],['Montserrat','Montserrat'],['Raleway','Raleway'],['Oswald','Oswald'],['Roboto Slab','Roboto Slab'],['Dancing Script','Dancing Script'],['Great Vibes','Great Vibes'],['Pacifico','Pacifico']
  ];
  function graphemes(text) {
    if (typeof Intl !== 'undefined' && Intl.Segmenter) { return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text), function (s) { return s.segment; }); }
    /* Older browsers: keep combining marks and variation selectors with their base. */
    return Array.from(text).reduce(function (a, ch) { if (/^[\u0300-\u036f\ufe00-\ufe0f\u3099\u309a]$/.test(ch) && a.length) { a[a.length - 1] += ch; } else { a.push(ch); } return a; }, []);
  }
  var verticalForms = {'、':'︑','。':'︒','，':'︐','：':'︓','；':'︔','！':'︕','？':'︖','「':'﹁','」':'﹂','『':'﹃','』':'﹄','（':'︵','）':'︶','【':'︻','】':'︼','［':'﹇','］':'﹈','〈':'︿','〉':'﹀','《':'︽','》':'︾','…':'︙'};
  function verticalRuns(text) {
    var out = [];
    graphemes(text).forEach(function (ch) {
      var upright = /[\u2e80-\u9fff\uac00-\ud7af\uf900-\ufaff\ufe10-\ufe4f\uff00-\uffef]|\p{Extended_Pictographic}|\p{Script=Han}/u.test(ch);
      var form = verticalForms[ch];
      if (form) { out.push({text:form, upright:true}); }
      else if (upright && ch !== 'ー' && ch !== '〜' && ch !== '～') { out.push({text:ch, upright:true}); }
      else if (out.length && !out[out.length-1].upright) { out[out.length-1].text += ch; }
      else { out.push({text:ch, upright:false}); }
    });
    return out;
  }
  function fallbackFamilies(text, lang) {
    var families = ['Noto Sans'];
    if (/[\u2e80-\u9fff\uf900-\ufaff\ufe10-\ufe4f]|\p{Script=Han}/u.test(text)) {
      families.unshift(lang === 'zh-Hans' ? 'Noto Sans SC' : lang === 'zh-Hant' ? 'Noto Sans TC' : 'Noto Sans JP');
      ['Noto Sans TC','Noto Sans SC'].forEach(function(f){if(families.indexOf(f)<0){families.push(f);}});
    }
    if (/[\u3040-\u30ff]/.test(text) && families.indexOf('Noto Sans JP') < 0) { families.push('Noto Sans JP'); }
    if (/[\uac00-\ud7af\u1100-\u11ff]/.test(text)) { families.push('Noto Sans KR'); }
    if (/[\u0600-\u06ff]/.test(text)) { families.push('Noto Sans Arabic'); }
    if (/[\u0590-\u05ff]/.test(text)) { families.push('Noto Sans Hebrew'); }
    if (/[\u0900-\u097f]/.test(text)) { families.push('Noto Sans Devanagari'); }
    if (/[\u0e00-\u0e7f]/.test(text)) { families.push('Noto Sans Thai'); }
    return families;
  }
  var cssCache = {};
  function loadFamily(family, text) {
    if (!cssCache[family]) {
      cssCache[family] = new Promise(function (resolve, reject) {
        var link = document.createElement('link'), done = false;
        var timer = setTimeout(function () { finish(new Error('font timeout')); }, 12000);
        function finish(err) { if (done) { return; } done = true; clearTimeout(timer); if (err) { delete cssCache[family]; link.remove(); reject(err); } else { resolve(); } }
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(family) + '&display=swap';
        link.onload = function () { finish(); }; link.onerror = function () { finish(new Error('font stylesheet')); };
        document.head.appendChild(link);
      });
    }
    return cssCache[family].then(function () {
      if (!document.fonts) { throw new Error('Font Loading API unavailable'); }
      return Promise.all([document.fonts.load('400 32px "' + family + '"', text), document.fonts.load('600 32px "' + family + '"', text)]);
    });
  }
  /* Remove only pixels connected to the image border and similar to its dominant corner colour. */
  function removeBorder(data, width, height, tolerance, cancelled) {
    var rgba = data.data, count = width * height;
    var corners = [0, width - 1, (height - 1) * width, count - 1].filter(function(i){return rgba[i*4+3]>=16;});
    if (!corners.length) { return Promise.resolve(data); } /* An already transparent image needs no colour removal. */
    function distance(a,b) { var r=rgba[a*4]-rgba[b*4],g=rgba[a*4+1]-rgba[b*4+1],bl=rgba[a*4+2]-rgba[b*4+2]; return Math.sqrt((r*r+g*g+bl*bl)/3); }
    var reference = corners[0], best = -1;
    corners.forEach(function (a) { var score = corners.filter(function (b) { return distance(a,b) <= tolerance; }).length; if (score > best) { best=score; reference=a; } });
    var r=rgba[reference*4],g=rgba[reference*4+1],b=rgba[reference*4+2];
    var seen=new Uint8Array(count), queue=new Uint32Array(count), start=0, end=0;
    function enqueue(i) {
      if (seen[i]) { return; } seen[i]=1;
      var p=i*4, dr=rgba[p]-r,dg=rgba[p+1]-g,db=rgba[p+2]-b;
      if (rgba[p+3] < 16 || (dr*dr+dg*dg+db*db)/3 <= tolerance*tolerance) { queue[end++]=i; }
    }
    for(var x=0;x<width;x++){enqueue(x);enqueue((height-1)*width+x);}
    for(var y=0;y<height;y++){enqueue(y*width);enqueue(y*width+width-1);}
    return new Promise(function(resolve,reject){
      function work(){
        if(cancelled && cancelled()){reject(new Error('cancelled'));return;}
        /* Include neighbours enqueued in this batch; yielding per frontier row is very slow in background tabs. */
        var processed=0;
        while(start<end && processed++<100000){var i=queue[start++];rgba[i*4+3]=0;var x=i%width;if(x>0){enqueue(i-1);}if(x<width-1){enqueue(i+1);}if(i>=width){enqueue(i-width);}if(i<count-width){enqueue(i+width);}}
        if(start<end){setTimeout(work,0);}else{resolve(data);}
      }
      work();
    });
  }
  var api={fonts:fonts,graphemes:graphemes,verticalRuns:verticalRuns,fallbackFamilies:fallbackFamilies,loadFamily:loadFamily,removeBorder:removeBorder};
  if(typeof module !== 'undefined' && module.exports){module.exports=api;}else{host.W99LabelTools=api;}
})(typeof window !== 'undefined' ? window : this);
